import React, { useState } from "react";
import {
  Button,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  TextField,
  IconButton,
  AppBar,
  Toolbar,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import MainSectionContainer from "../../../subComponents/MainSectionContainer";
import {
  addNewStaff,
  assignClassToTeacher,
  deleteStaff,
  updateStaff,
} from "../../../firebase/functions";
import { useDispatch, useSelector } from "react-redux";
import { staffThunk } from "../../../redux/adminSlice";

const Staff = () => {
  const [open, setOpen] = useState(false);
  const [staffName, setStaffName] = useState("");
  const [role, setRole] = useState("");
  const [staffId, setStaffID] = useState("");
  const [isModalTable, setIsModalTable] = useState("");
  const dispatch = useDispatch();

  const staffData = useSelector((state) => state.admin.staff.data);

  const handleModalChange = () => {
    setOpen((prev) => !prev);
  };
  const createEntry = () => {
    addNewStaff({ name: staffName, role }).then(() => {
      console.log("New Teacher Entry Created");
      handleModalChange();
    });
  };
  const updateStaffData = () => {
    updateStaff(staffName, staffId).then(() => {
      dispatch(staffThunk());
      handleModalChange();
    });
    setIsModalTable(false);
  };
  return (
    <Grid
      container
      direction="column"
      height="100%"
      paddingTop="12px"
      bgcolor="primary.opaque">
      <Grid item>
        <AppBar component="nav">
          <Toolbar>
            <Grid
              container
              justifyContent="space-around"
              width="100%"
              spacing={3}>
              <Grid item>
                <Typography component="b">
                  No of staff:{" "}
                  <span style={{ fontWeight: "bold" }}>{staffData.length}</span>
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleModalChange}>
                  Add a Staff
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Grid>
      <Grid item xs width="100%">
        <MainSectionContainer>
          <Modal
            open={open}
            onClose={handleModalChange}
            createEntry={isModalTable ? updateStaffData : createEntry}
            role={role}
            setRole={setRole}
            staffName={staffName}
            setStaffName={setStaffName}
          />

          <StaffTable
            staffData={staffData}
            setIsModalTable={setIsModalTable}
            setStaffID={setStaffID}
            openModal={handleModalChange}
            setStaffName={setStaffName}
          />
        </MainSectionContainer>
      </Grid>
    </Grid>
  );
};

export default Staff;

const Modal = ({
  onClose,
  open,
  role,
  staffName,
  setStaffName,
  setRole,
  createEntry,
}) => {
  const handleChange = (e) => {
    if (e.target.name === "role") setRole(e.target.value);
    if (e.target.name === "staffName") setStaffName(e.target.value);
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <Grid container spacing={2} maxWidth="80vw" padding="0px 16px 12px">
        <Grid item xs={12}>
          <DialogTitle>Add a Staff</DialogTitle>
        </Grid>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={6}>
            <TextField
              id="standard-basic"
              name="staffName"
              label="Standard"
              variant="standard"
              value={staffName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Role</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="role"
                id="demo-simple-select"
                value={role}
                label="Role"
                onChange={handleChange}>
                <MenuItem value="Administrator">Administrator</MenuItem>
                <MenuItem value="DOS">DOS</MenuItem>
                <MenuItem value="Teacher">Teacher</MenuItem>
                <MenuItem value="Cleaner">Cleaner</MenuItem>
                <MenuItem value="Security">Security</MenuItem>
                <MenuItem value="Driver">Driver</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button
            // variant="contained"
            onClick={createEntry}
            style={{
              width: "60%",
              maxWidth: 250,
            }}>
            Create Entry
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

const StaffTable = ({
  staffData,
  setStaffID,
  setStaffName,
  openModal,
  setIsModalTable,
}) => {
  const dispatch = useDispatch();
  return (
    <Grid container>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 250 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={{
                "& > *": {
                  fontWeight: "bold",
                  color: "secondary.main",
                },
              }}>
              <TableCell>Staff's Name</TableCell>
              <TableCell align="right">Role</TableCell>
              <TableCell align="right">Assign Class</TableCell>
              <TableCell align="right">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {staffData.map((data, i) => (
              <TableRow
                key={data.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {data.name}
                </TableCell>
                <TableCell align="right">{data.role}</TableCell>
                <TableCell align="right">
                  {data.role.toLowerCase() === "teacher" && (
                    <AssignClass id={data.id} className={data.class} />
                  )}
                </TableCell>
                <TableCell align="right">
                  <Button
                    onClick={() =>
                      deleteStaff(data.id).then(() => {
                        dispatch(staffThunk());
                      })
                    }
                    startIcon={<DeleteIcon />}>
                    Del
                  </Button>
                </TableCell>
                <TableCell align="right">
                  <Button
                    onClick={() => {
                      setStaffName(data.name);
                      setIsModalTable(true);
                      setStaffID(data.id);
                      openModal();
                    }}
                    startIcon={<EditIcon />}>
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

const AssignClass = ({ id, className }) => {
  const [schlClass, setSchlClass] = useState(className);

  const classesData = useSelector((state) => state.admin.classes.data);

  const handleChange = (event) => {
    const className = event.target.value;

    setSchlClass(className);
    assignClassToTeacher(id, className);
  };
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Classes</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        variant="standard"
        value={schlClass}
        label="Classes"
        onChange={handleChange}>
        {classesData.map((classData) => (
          <MenuItem value={classData.name}>{classData.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
